type BoxCounterOptions = {
  containerSelector?: string;
  minusSelector?: string;
  plusSelector?: string;
  inputSelector?: string;
  oldPriceSelector?: string;
  actualPriceSelector?: string;
};

function parsePrice(text: string): { value: number; suffix: string } | null {
  const raw = (text ?? '').trim();
  if (!raw) return null;

  const digitsOnly = raw.replace(/[^\d]/g, '');
  if (!digitsOnly) return null;

  const value = Number(digitsOnly);
  if (!Number.isFinite(value)) return null;

  const suffixMatch = raw.match(/([^\d\s][^\d]*)$/);
  const suffix = suffixMatch ? ` ${suffixMatch[1].trim()}` : ' ₽';

  return { value, suffix };
}

function formatPrice(value: number, suffix: string): string {
  const normalized = Number.isFinite(value) ? Math.max(0, Math.round(value)) : 0;
  return `${new Intl.NumberFormat('ru-RU').format(normalized)}${suffix}`;
}

function toQty(raw: unknown): number {
  const n = Number(raw);
  if (!Number.isFinite(n)) return 1;
  return Math.max(1, Math.trunc(n));
}

export function initBoxContainerCounter({
  containerSelector = '.js-box-container',
  minusSelector = '.js-btn-minus',
  plusSelector = '.js-btn-plus',
  inputSelector = '.js-count',
  oldPriceSelector = '.js-old-price',
  actualPriceSelector = '.js-actual-price'
}: BoxCounterOptions = {}): void {
  const containers = document.querySelectorAll<HTMLElement>(containerSelector);
  if (!containers.length) return;

  containers.forEach(container => {
    const plusBtn = container.querySelector<HTMLButtonElement>(plusSelector);
    const minusBtn = container.querySelector<HTMLButtonElement>(minusSelector);
    const input = container.querySelector<HTMLInputElement>(inputSelector);
    const oldPriceEl = container.querySelector<HTMLElement>(oldPriceSelector);
    const actualPriceEl = container.querySelector<HTMLElement>(actualPriceSelector);

    // Работаем только если есть ВСЕ необходимые элементы.
    if (!plusBtn || !minusBtn || !input || !oldPriceEl || !actualPriceEl) return;

    const baseQty = toQty(input.value || input.getAttribute('value') || 1);
    const baseActual = parsePrice(actualPriceEl.textContent || '');
    const baseOld = parsePrice(oldPriceEl.textContent || '');
    if (!baseActual || !baseOld) return;

    const unitActual = baseActual.value / baseQty;
    const unitOld = baseOld.value / baseQty;

    const update = (qty: number): void => {
      const nextQty = toQty(qty);
      const nextValue = String(nextQty);

      input.value = nextValue;
      input.setAttribute('value', nextValue);

      actualPriceEl.textContent = formatPrice(unitActual * nextQty, baseActual.suffix);
      oldPriceEl.textContent = formatPrice(unitOld * nextQty, baseOld.suffix);
    };

    plusBtn.addEventListener('click', e => {
      e.preventDefault();
      update(toQty(input.value) + 1);
    });

    minusBtn.addEventListener('click', e => {
      e.preventDefault();
      update(toQty(input.value) - 1);
    });

    input.addEventListener('change', () => {
      update(toQty(input.value));
    });
  });
}

